import { Currency } from 'core/agency/Agency';
import { numberWithCommas } from 'utils/StringUtil';
import _ from 'lodash';
import i18n from 'i18n';

export function getPriceValue(
  currency: Currency | string,
  amount: number
): number {
  let targetAmount = amount;
  const isNegative = amount < 0;
  if (isNegative) {
    targetAmount = amount * -1;
  }
  let result;
  switch (currency) {
    case Currency.MYR:
    case Currency.USD:
      result = _.floor(targetAmount, 2);
      break;
    default:
      if (targetAmount < 1) {
        result = _.floor(targetAmount, 2);
      } else {
        result = Math.floor(targetAmount);
      }
      break;
  }
  return isNegative ? result * -1 : result;
}

export function getDecimalPlaceCount(currency: Currency | string): number {
  switch (currency) {
    case Currency.MYR:
    case Currency.USD:
      return 2;
    default:
      return 0;
  }
}

export function formatPriceAny(amount: number): string {
  return numberWithCommas(amount);
}

export function formatPrice(
  currency: Currency | string,
  amount: number
): string {
  return numberWithCommas(getPriceValue(currency, amount));
}

export function getCurrencyLabel(currency: Currency | string): string {
  const i18nKey = `currency.${currency.toLowerCase()}`;
  return i18n.exists(i18nKey) ? i18n.t(i18nKey) : currency;
}

export function formatPriceWithCurrency(
  currency: Currency | string,
  amount: number
) {
  return `${getCurrencyLabel(currency)} ${formatPrice(currency, amount)}`;
}
